import {useEffect, useState} from 'react';
import {useParams} from 'react-router';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';
function _authH() { const t = localStorage.getItem('access_token'); return t ? {'Authorization': `Bearer ${t}`} : {}; }

const useReadbookTask = () => {
    const {readbookId} = useParams();
    const [task, setTask] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!readbookId) { setTask(null); setLoading(false); return; }
        fetch(`${BASE}/api/documents/readbook_tasks/${encodeURIComponent(readbookId)}`, {headers: _authH()})
            .then(r => r.status === 404 ? null : r.ok ? r.json() : null)
            .then(data => { setTask(data); setLoading(false); })
            .catch(err => { setError(err); setLoading(false); });
    }, [readbookId]);

    return {task, loading, error};
};

export default useReadbookTask;
